import {
  NOTIFICATION_FIELD_PAYMENT,
  NOTIFICATION_FIELD_PAYMENT_RECEIVED,
} from "./NotificationField";

import type { ObjectWithId } from "../utils/ObjectWithId";
import type { NotificationFieldType } from "./NotificationField";

export interface ExtraNotificationFields {
  paymentNotificationSettingsFields?: string[];
  paymentReceivedNotificationSettingsFields?: string[];
}

export const EXTRA_NOTIFICATION_FIELDS_MAP: Record<
  NotificationFieldType,
  keyof ExtraNotificationFields
> = {
  [NOTIFICATION_FIELD_PAYMENT]: "paymentNotificationSettingsFields",
  [NOTIFICATION_FIELD_PAYMENT_RECEIVED]:
    "paymentReceivedNotificationSettingsFields",
};

export interface NotificationSettings extends ObjectWithId {
  secret: string;
  url: string;
  enabled: boolean;
  failedEmail: string;
  active: boolean;
  createdAt: string;
  extraNotificationFields: ExtraNotificationFields;
  paymentReceivalEnabled?: boolean;
}

export type NotificationSettingsUpdate = Pick<
  NotificationSettings,
  "enabled" | "url" | "failedEmail" | "extraNotificationFields"
>;

export const PROPERTY_EXTRA_FIELDS = "extraNotificationFields";
